<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Zastosowania</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <router-link to="/appliances">Zastosowania</router-link>
        </li>
        <li class="active">
          <strong>Nowe</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Opis zastosowania [pl]</h5>
            <span class="ibox-toggle" @click="isPlOpen = !isPlOpen">
              <i :class="chevronPlClass"></i>
            </span>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content" v-show="isPlOpen">
              <div class="form-group">
                <label class="control-label col-sm-2">Nazwa</label>
                <div class="col-sm-10">
                  <input
                    v-model="applianceObj.name_pl"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Nazwa"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.name_pl" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.name_pl[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Opis</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="applianceObj.description"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Opis zastosowania [en]</h5>
            <span class="ibox-toggle" @click="isEnOpen = !isEnOpen">
              <i :class="chevronEnClass"></i>
            </span>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content" v-show="isEnOpen">
              <div class="form-group">
                <label class="control-label col-sm-2">Nazwa</label>
                <div class="col-sm-10">
                  <input
                    v-model="applianceObj.name_en"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Nazwa"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.name_en" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.name_en[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Opis</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="applianceObj.description_en"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_en"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_en[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Opis zastosowania [de]</h5>
            <span class="ibox-toggle" @click="isDeOpen = !isDeOpen">
              <i :class="chevronDeClass"></i>
            </span>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content" v-show="isDeOpen">
              <div class="form-group">
                <label class="control-label col-sm-2">Nazwa</label>
                <div class="col-sm-10">
                  <input
                    v-model="applianceObj.name_de"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Nazwa"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.name_de" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.name_de[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Opis</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="applianceObj.description_de"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_de"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_de[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Opis zastosowania [de_de]</h5>
            <span class="ibox-toggle" @click="isDeDeOpen = !isDeDeOpen">
              <i :class="chevronDeDeClass"></i>
            </span>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content" v-show="isDeDeOpen">
              <div class="form-group">
                <label class="control-label col-sm-2">Nazwa</label>
                <div class="col-sm-10">
                  <input
                    v-model="applianceObj.name_cpde"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Nazwa"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.name_cpde"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.name_cpde[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Opis</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="applianceObj.description_cpde"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_cpde"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_cpde[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Opis zastosowania [de_en]</h5>
            <span class="ibox-toggle" @click="isDeEnOpen = !isDeEnOpen">
              <i :class="chevronDeEnClass"></i>
            </span>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content" v-show="isDeEnOpen">
              <div class="form-group">
                <label class="control-label col-sm-2">Nazwa</label>
                <div class="col-sm-10">
                  <input
                    v-model="applianceObj.name_cpen"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Nazwa"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.name_cpen"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.name_cpen[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Opis</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="applianceObj.description_cpen"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_cpen"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_cpen[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Konfiguracja zastosowania</h5>
            <span class="ibox-toggle" @click="isConfigOpen = !isConfigOpen">
              <i :class="chevronConfigClass"></i>
            </span>
          </div>
          <div class="ibox-content" v-show="isConfigOpen">
            <div class="form-group">
              <label class="control-label col-sm-2">Obrazek</label>
              <div class="col-sm-3">
                <picture-input
                  ref="pictureInput"
                  width="300"
                  height="300"
                  margin="16"
                  accept="image/jpeg,image/png"
                  size="10"
                  button-class="btn"
                  :custom-strings="{
                    upload: '<h1>Uploading!</h1>',
                    drag: 'Drag & Drop',
                  }"
                  @change="changePhoto"
                >
                </picture-input>
              </div>
            </div>

            <div class="hr-line-dashed"></div>

            <div class="form-group">
              <div class="col-sm-4 col-sm-offset-2">
                <router-link class="btn btn-white" to="/appliances">
                  Anuluj
                </router-link>
                <button
                  v-if="canAddAppliance"
                  @click="create"
                  class="btn btn-primary"
                >
                  Dodaj
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from "vue";
import { hasPermission } from "../../permissions";
import { appliancesPermissionsConst } from "../../constants/productionConstants";
import { useStore } from "vuex";
import router from "../../router/router";
import PictureInput from "vue-picture-input";

export default {
  name: "AppliancesCreate",
  mixins: [],
  components: {
    PictureInput,
  },
  props: {},

  setup() {
    const applianceObj = ref({});
    const errorsAdminData = ref({});
    const showErrors = ref(false);
    const store = useStore();
    const canAddAppliance = computed(() =>
      hasPermission(appliancesPermissionsConst.add)
    );
    const createAppliancesData = computed(
      () => store.getters.getCreateAppliancesData
    );

    const isPlOpen = ref(true);
    const isEnOpen = ref(true);
    const isDeOpen = ref(true);
    const isDeDeOpen = ref(true);
    const isDeEnOpen = ref(true);
    const isConfigOpen = ref(true);

    const chevronPlClass = computed(() =>
      isPlOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronEnClass = computed(() =>
      isEnOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronDeClass = computed(() =>
      isDeOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronDeDeClass = computed(() =>
      isDeDeOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronDeEnClass = computed(() =>
      isDeEnOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronConfigClass = computed(() =>
      isConfigOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );

    const create = () => {
      if (!canAddAppliance.value) {
        return;
      }
      showErrors.value = true;
      store.dispatch("createAppliances", applianceObj.value);
    };

    const changePhoto = (image) => {
      if (image.srcElement?.files[0]) {
        applianceObj.value.icon = image.srcElement?.files[0];
      }
    };

    watch(
      () => createAppliancesData.value,
      function (newValue) {
        if (newValue.status === 201) {
          router
            .push({ name: "AppliancesList", path: "/appliances" })
            .then(() => {
              store.dispatch("showToaster", {
                type: "success",
                content: "Nowy zastosowanie zostało dodane",
              });
            });
        } else {
          var msg = [];
          for (const [key, value] of Object.entries(newValue.data)) {
            msg.push(key + ": " + value);
          }

          store.dispatch("showToaster", {
            type: "error",
            content: msg[0],
          });
          errorsAdminData.value = newValue;
        }
      }
    );

    return {
      canAddAppliance,
      applianceObj,
      errorsAdminData,
      showErrors,
      create,
      changePhoto,
      isPlOpen,
      isEnOpen,
      isDeOpen,
      isDeDeOpen,
      isDeEnOpen,
      isConfigOpen,
      chevronPlClass,
      chevronEnClass,
      chevronDeClass,
      chevronDeDeClass,
      chevronDeEnClass,
      chevronConfigClass,
    };
  },
  computed: {},
};
</script>

<style scoped>
.ibox-title {
  position: relative;
}
.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 12px;
  cursor: pointer;
}
</style>
